import { MethodsEnum } from "../enums/Methods.ts";
import { Medico } from "../models/Medico.ts";
import handleService from "./apiService.ts";
import { emitirNotificacao } from "../contexts/NotificationContext.tsx";

const create = async (medico: Medico) => {
  // id nunca deve ser enviado num cadastro novo - ver pacienteService.create para o motivo.
  const { id, ...medicoSemId } = medico as any;
  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/medico",
    data: medicoSemId,
  });
  if (result?.data?.id) {
    emitirNotificacao({
      id: `cadastro-medico-${result.data.id}`,
      tipo: "cadastro_medico",
      titulo: "Novo médico cadastrado",
      descricao: `${result.data.nome} foi adicionado ao cadastro de médicos.`,
      link: "/medico/listagem",
    });
  }
  return result;
};

const update = async (instrumentador) => {
  const result = await handleService({
    method: MethodsEnum.PATCH,
    endpoint: "/medico/alterar",
    data: instrumentador,
  });
  return result;
};

const medicoService = { create, update };

export default medicoService;
